import { UserManager } from 'oidc-react';
import { OIDC_CONFIG } from '../../constants';

export const userManager = new UserManager({
	...OIDC_CONFIG,
	// Expiry events and API failures share renewUser() in authSession.
	automaticSilentRenew: false,
	loadUserInfo: false,
	revokeTokensOnSignout: true,
	revokeTokenTypes: ['refresh_token'],
});
